import { ArrowRight, CheckCircle2 } from "lucide-react";
import type { FC } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import type { InsightsFlow } from "../hooks/useInsightsFlow";

const Count: FC<{ n: number; label: string; dot: string }> = ({
  n,
  label,
  dot
}) => (
  <span className="flex items-center gap-1.5 text-base">
    <span className={cn("size-1.5 rounded-full", dot)} aria-hidden />
    <span className="font-medium text-fg tabular-nums">{n}</span>
    <span className="text-fg-2">{label}</span>
  </span>
);

/**
 * Over the sections: how many facts need the attorney, are proposed and are
 * settled, and Next, which brings the next ask into view and focus.
 */
export const NeedsYouStrip: FC<{
  counts: { need: number; proposed: number; settled: number };
  flow: InsightsFlow;
}> = ({ counts, flow }) => (
  <div
    className="sticky top-0 z-10 flex flex-wrap items-center gap-x-4 gap-y-1.5 border-b border-line-1 bg-surface px-4 py-2"
    data-testid="needs-you-strip"
  >
    <Count n={counts.need} label="Need You" dot="bg-warn" />
    <Count n={counts.proposed} label="Proposed" dot="bg-info" />
    <Count n={counts.settled} label="Settled" dot="bg-success" />
    <div className="ml-auto flex min-w-0 items-center gap-2">
      {flow.current ? (
        <>
          <span className="truncate text-sm text-fg-3">
            Now: <span className="text-fg-2">{flow.current.label}</span>
          </span>
          <Button variant="primary" size="sm" onClick={flow.next}>
            Next
            <ArrowRight data-icon="inline-end" />
          </Button>
        </>
      ) : (
        <span
          className="flex items-center gap-1.5 text-sm text-fg-2"
          data-testid="needs-you-clear"
        >
          <CheckCircle2 className="size-3.5 text-success" aria-hidden />
          Nothing needs you right now
        </span>
      )}
    </div>
  </div>
);
